import React, { useState, useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';
import { getCategoryLink, getCategoryID } from './utils/category.js';
import { getImageUrl } from './utils/image.js';
import { getCategoryDiscount } from './utils/saleFlag.js';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';
import { S as SaleFlag } from './SaleFlag-uqbhEU3Y.js';
import Link from './components/Link/index.js';

const CategoryItem = ({ item, locale, lazyLoad, allowAboveFoldAnimation = false }) => {
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { asPath } = useRouter();
    const [isHovered, setIsHovered] = useState(false);
    const { data } = useContext(CoreContext);
    const { product: { imageHeight, imageWidth }, promo: { displaySaleFlag = false, discount: promoDiscount = '', categoriesSaleExludeList = [], } = {}, } = data.siteConfig;
    const url = getCategoryLink(item.url_path, locale);
    const imgUrl = getImageUrl(item.image);
    const imgUrlHover = item.image_hover ? getImageUrl(item.image_hover) : null;
    const categoryID = getCategoryID(item);
    const blocNameCta = tButton('shopNow');
    const blocNameImage = `category image ${item.name}`;
    const blocNameName = `category name ${item.name}`;
    // TODO: replace to the real categoryId when the GetScandiMenu id prop will be fixed on the BE
    const categoryId = 1;
    const categoryPromoDiscount = getCategoryDiscount(promoDiscount, categoryId, categoriesSaleExludeList);
    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    return (React.createElement("div", { className: "item" },
        React.createElement("div", { className: "product-item-container" },
            React.createElement("div", { className: "stack" },
                React.createElement(Link, { href: url, className: "item-ctg-copy", black: true, noUnderline: true, noTabbing: true, noClass: true },
                    React.createElement("h2", { className: "subtitle-category font-sub-heading", "data-event-name": "bloc_interact", "data-bloc-name": blocNameName },
                        React.createElement("span", { "data-aos": "fade", "data-gsap-delay": "200", ...(!allowAboveFoldAnimation && { 'data-gsap-above-fold-stop': true }) }, item.name))),
                React.createElement("div", { className: "ctg-image-wrapper", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
                    React.createElement(Link, { id: `CD_${categoryID}`, href: url, noClass: true },
                        React.createElement(SaleFlag, { show: displaySaleFlag, discount: categoryPromoDiscount }),
                        React.createElement("div", { className: "ctg-image", "data-gsap": "fade", ...(!allowAboveFoldAnimation && { 'data-gsap-above-fold-stop': true }), "data-event-name": "bloc_interact", "data-bloc-name": blocNameImage },
                            React.createElement("img", { src: imgUrl, alt: item.name, width: imageWidth, height: imageHeight, ...(lazyLoad && { loading: 'lazy' }), onError: () => logImgLoadErrorToRelic(asPath, imgUrl) }),
                            imgUrlHover && (React.createElement("img", { src: imgUrlHover, alt: item.name, width: imageWidth, height: imageHeight, className: `hover ${isHovered ? 'hover-active' : ''}`, ...(lazyLoad && { loading: 'lazy' }), onError: () => logImgLoadErrorToRelic(asPath, imgUrlHover), loading: "lazy" })))),
                    React.createElement("div", { className: "hover-content", "data-event-name": "bloc_interact", "data-bloc-name": blocNameCta },
                        React.createElement(Link, { href: url, className: "btn btn-main shop-now-button", noTabbing: true, noClass: true },
                            React.createElement("span", null, tButton('shopNow')))))))));
};

export { CategoryItem as C };
//# sourceMappingURL=CategoryItem-P72rIIRv.js.map
